/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { Loading, InlineNotification } from '@carbon/react';
import React from 'react';
import { useIntl } from 'react-intl';

import { ApiStatus } from '@ibm-watson/shared/ts';
import { SecurityTab as messages } from '../messages';

interface SecurityLoadingPublicKeyProps {
  /**
   *
   */
  subscribeStatus: ApiStatus;
}
export const SecurityLoadingPublicKey = ({
  subscribeStatus
}: SecurityLoadingPublicKeyProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <div>
      {subscribeStatus === ApiStatus.ERROR && (
        <InlineNotification
          hideCloseButton
          kind="error"
          role="alert"
          subtitle={t(messages.IBMPublicKeyErrorText)}
          title={t(messages.IBMPublicKeyErrorTitle)}
          statusIconDescription={t(messages.IBMPublicKeyErrorTitle)}
        />
      )}
      {subscribeStatus === ApiStatus.LOADING && (
        <Loading
          description={t(messages.IBMPublicKeyLoading)}
          withOverlay={false}
          small
        />
      )}
    </div>
  );
};
